// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__d1Ld9","icon":"Slider_icon__s2CDM","level":"Slider_level__3rPir","volume":"Slider_volume__ngOCa"};